<template>
  <div class="signup-form scrollbar">
    <div class="signup-form__header">
      <h1>Start Free Trial Now.</h1>
      <span class="header-promo">Enjoy full access and <strong>$20 free credits</strong> on us during your trial!</span>
    </div>
    <div class="signup-form__body">
      <form class="signup-form__form" @submit.prevent="handleCreateAccount">
        <div class="row">
          <div class="col-6">
            <label class="required" for="form_create-firstname">First Name</label>
            <input
              id="form_create-firstname"
              v-model="userCreateFirstname"
              type="text"
              placeholder="Enter your name"
            >
          </div>
          <div class="col-6">
            <label class="required" for="form_create-lastname">Last Name</label>
            <input
              id="form_create-lastname"
              v-model="userCreateLastname"
              type="text"
              placeholder="Enter your name"
            >
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <label class="required" for="form_create-email">Email</label>
            <input
              id="form_create-email"
              v-model="userCreateEmail"
              type="text"
              placeholder="Enter your email"
            >
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <label for="form_create-org">Organization</label>
            <input
              id="form_create-org"
              v-model="userCreateOrganization"
              type="text"
              placeholder="Enter your organization name"
            >
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <label class="required" for="form_create-username">Username</label>
            <input
              id="form_create-username"
              v-model="userCreateUsername"
              type="text"
              placeholder="Enter your preferred username"
            >
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <label class="required" for="form_create-password">Password</label>
            <input
              id="form_create-password"
              v-model="userCreatePassword"
              type="password"
              maxlength="72"
            >
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <label class="required" for="form_create-confirm_password">Confirm Password</label>
            <input
              id="form_create-confirm_password"
              v-model="userConfirmPassword"
              type="password"
              maxlength="72"
            >
          </div>
        </div>

        <div class="submit-container">
          <span v-if="error" class="_error">{{ error }}</span>
          <span v-if="successMessage" class="_success">{{ successMessage }}</span>
          <button type="submit" class="button">Create Free Account</button>
        </div>
      </form>
    </div>
    <h3 class="new-user">Already have an account? <button class="button-link" @click="handleGoToLogin">Sign in.</button></h3>
  </div>
</template>

<script>
import DatastoreConnect from '@/assets/js/DatastoreFunctions/datastore-interface';
import { event } from 'vue-gtag';

export default {
  name: 'SignupFormLanding',
  data() {
    return {
      dataConnect: null,
      userCreateFirstname: '',
      userCreateLastname: '',
      userCreateUsername: '',
      userCreateEmail: '',
      userCreateOrganization: '',
      userCreatePassword: '',
      userConfirmPassword: '',
      error: '',
      successMessage: '',
    };
  },
  computed: {
    isSaas() {
      return this.$store.state.appVersion.isSaas;
    },
    version() {
      return this.$store.state.appVersion.version;
    },
    frontendVersion() {
      return this.$store.state.appVersion.frontendVersion;
    },
  },
  created() {
    this.dataConnect = new DatastoreConnect();
  },
  methods: {
    handleGoToLogin() {
      this.$router.push({ path: '/login' });
    },
    handleError(error) {
      if (error.code === 101) {
        this.error = error.message;
      }
    },
    async handleRegister() {
      this.successMessage = '';
      this.error = '';
      // Validate password
      if (!this.userCreateFirstname) {
        this.error = "Missing first name.";
        return;
      }

      if (!this.userCreateLastname) {
        this.error = "Missing last name.";
        return;
      }

      if (!this.userCreateEmail) {
        this.error = "Missing email.";
        return;
      }

      const resp = await this.dataConnect.registerNewUser({
        email: this.userCreateEmail,
        firstname: this.userCreateFirstname,
        lastname: this.userCreateLastname,
        company: this.userCreateOrganization,
      })
        .catch((error) => {
          console.log(error);
          alert(error);
        });
      if (!resp || resp.error || !resp.result) {
        if (resp && resp.error) {
          console.error(resp.error);
          this.handleError(resp.error);
          return;
        }
      }

      this.successMessage = resp.result;
    },
    async handleCreateAccount() {
      event('register_submit', {
        category: 'registration',
        label: 'User submitted the registration form',
      });

      this.successMessage = '';
      this.error = '';
      // Validate password
      if (!this.userCreateFirstname) {
        this.error = "Missing first name.";
        event('register_failure', {
          category: 'registration',
          label: 'User failed to register',
          reason: "Missing first name.",
        });
        return;
      }

      if (!this.userCreateLastname) {
        this.error = "Missing last name.";
        event('register_failure', {
          category: 'registration',
          label: 'User failed to register',
          reason: "Missing last name.",
        });
        return;
      }

      if (!this.userCreateUsername) {
        this.error = "Missing username.";
        event('register_failure', {
          category: 'registration',
          label: 'User failed to register',
          reason: "Missing username.",
        });
        return;
      }

      if (!this.userCreateEmail) {
        this.error = "Missing email.";
        event('register_failure', {
          category: 'registration',
          label: 'User failed to register',
          reason: "Missing email.",
        });
        return;
      }

      if (!this.userCreatePassword) {
        this.error = "Missing password.";
        event('register_failure', {
          category: 'registration',
          label: 'User failed to register',
          reason: "Missing password.",
        });
        return;
      }

      if (!this.userConfirmPassword) {
        this.error = "Missing confirm password.";
        event('register_failure', {
          category: 'registration',
          label: 'User failed to register',
          reason: "Missing confirm password.",
        });
        return;
      }

      if (this.userCreatePassword !== this.userConfirmPassword) {
        this.error = "Confirm password does not match.";
        event('register_failure', {
          category: 'registration',
          label: 'User failed to register',
          reason: "Confirm password does not match.",
        });
        return;
      }
      const resp = await this.dataConnect.registerNewUser({
        username: this.userCreateUsername,
        email: this.userCreateEmail,
        password: this.userCreatePassword,
        firstname: this.userCreateFirstname,
        lastname: this.userCreateLastname,
        company: this.userCreateOrganization,
      })
        .catch((error) => {
          console.log(error);
          alert(error);
        });
      if (!resp || resp.error || !resp.result) {
        if (resp && resp.error) {
          console.error(resp.error);
          event('register_failure', {
            category: 'registration',
            label: 'User failed to register',
            reason: resp.error,
          });
          this.handleError(resp.error);
          return;
        }
      }

      event('register_success', {
        category: 'registration',
        label: 'User successfully registered',
      });
      this.successMessage = resp.result;
    },
  },

};
</script>

<style lang="scss" scoped>

.signup-form {
  width: 610px;
  padding: 50px 80px 50px 80px;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  max-height: 100%;
  box-shadow: 0 0 35px rgb(0 0 0 / 50%), 0 0 10px rgb(0 0 0 / 50%);
  // min-height: fit-content;
  // margin: auto;
  @include themify() {
    color: themed('body-text-color');
  }
  background: rgba(255, 255, 255, 0.825);
  border-radius: 16px;
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.9);

  &__header {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    z-index: 10;
    margin-bottom: 10px;

    h1 {
      text-align: center;
      font-size: 24px;
    }
  }

  &__body {
    display: flex;
    flex-direction: column;
    text-align: left;
    // margin-bottom: 16px;
    flex: 1 1 auto;
    @include themify() {
      color: themed('body-text-color');
    }
  }

  .new-user {
    text-align: center;
    font-weight: normal;
    font-size: 16px;
    padding-top: 20px;
    margin-top: auto;
    margin-bottom: 0.5rem;
  }
}

@media (max-width: 1600px) {
  .signup-form {
    width: 520px;
  }
}
@media (max-width: $breakpoint-xl) {
  .signup-form {
    width: 420px;
  }
}
@media (max-width: $breakpoint-lg) {
  .signup-form {
    width: 610px;
  }
}
@media (max-width: $breakpoint-md) {
  .signup-form {
    width: 100%;
  }
}
@media (max-width: $breakpoint-sm) {
  .signup-form {
    padding: 32px;
  }
}

form {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  gap: 8px;

  label {
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 2px;

      &.required::after {
      content: '*';
      font-size: 14px;
      font-weight: 700;
      padding-left: 1px;
      @include themify() {
        color: themed('color-primary');
      }
    }
  }

  input {
    width: 100%;
    height: 38px;
    background: rgba(var(--color-white-rgb), 0.5);
    padding: 10px;
    border: 2px solid rgba(189, 186, 186, 0.75);
    border-radius: 8px;
    color: black;
    font-size: 16px;
    outline: none;

    &:focus, &:focus-visible {
      @include themify() {
        border: 2px solid themed('color-primary');
        box-shadow:  0 0px 2px themed('color-primary-300');
      }
      outline: 2px solid transparent;
      outline-offset: 2px;
    }
  }
  input:not(:last-of-type) {
    // margin-bottom: 16px;
  }

  button[type=submit] {
    letter-spacing: 0.1em;
    width: 100%;
    height: 42px;
    border-radius: 6px;
  }

  .submit-container {
    margin-top: 8px;

    span._error {
      margin: 0 0 4px 0;
      font-weight: 400;
      font-size: 16px;
      text-align: left;
      margin-bottom: 0.5rem;
      @include themify() {
        color: themed('login-error');
      }
    }

    span._success {
      margin: 0 0 4px 0;
      font-weight: 400;
      font-size: 16px;
      text-align: left;
      margin-bottom: 0.5rem;
      @include themify() {
        color: themed('login-success');
      }
    }
  }
}

@media (max-height: 750px) {
  .signup-form {
    padding: 20px 50px 20px 50px;
    overflow: auto;
  }

  .signup-form__header h1 {
    margin-top: 0;
    font-size: 20px;
  }

  form {
    gap: 4px;
  }

  form label {
    font-size: 12px;
  }

  form input {
    height: 32px;
  }

  form button[type=submit] {
    height: 36px;
  }
}

@media (max-height: 850px) {
  .signup-form__header h1 {
    margin-top: 0;
    font-size: 20px;
  }

  form {
    gap: 6px;
  }

  form label {
    font-size: 14px;
  }

  form input {
    height: 32px;
  }

  form button[type=submit] {
    height: 40px;
  }
}

.header-promo {
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  color: var(--color-primary);
  border: solid 2px var(--color-accent);
  background: rgba(255, 255, 255, 0.375);
  border-radius: 8px;
  margin-top: 10px;
  padding: 4px;
}
</style>
